import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  Ward,
  WardCreate,
  WardDelete,
  WardLoad,
  WardUpdate
} from "../../models/ward";

@Injectable()
export abstract class WardBackend {
  abstract load(request: WardLoad): Observable<Ward>;

  abstract list(): Observable<Ward[]>;

  abstract listByFacility(facilityUuid: string): Observable<Ward[]>;

  abstract create(request: WardCreate): Observable<string>;

  abstract delete(request: WardDelete): Observable<void>;

  abstract update(request: WardUpdate): Observable<void>;
}
